// UnitPermissionSummaryTable
// ***********************************************************************************************************************
import * as React from "react";
import { EnumHelper, GroupPermissionLevel, UserGroupType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUnitSummaryNode } from "../../../../models/unit/unitSummaryNode";
import { List } from "../../../framework/List/List";
import { PanelTitle } from "../../../framework/Panel/PanelTitle";
import { Box } from "@mui/material";

export interface IUnitPermissionSummaryTableProp {
    classes?: string;
    unitNode: IUnitSummaryNode;
    parentName: string;
    accessRightNoneTitle: string;
    accessRightReadTitle: string;
    accessRightWriteTitle: string;
    additionalPermissionTitle: string[];
    additionalPermissionsInUse: boolean;
    showInheritedPermissions: boolean;
    showUserGroups: boolean;
    showUsers: boolean;
    filter: string;
    getAdditionalPermissionInUse: (permission: number, additionalPermissionIndex: number) => boolean;
}

export class UnitPermissionSummaryTable extends React.Component<IUnitPermissionSummaryTableProp, {}> {
    render() {
        const props = this.props;
        const unitNode = props.unitNode;
        if (!unitNode) return null;
        const filterLow = props.filter.toLowerCase();
        const userGroups = unitNode.userGroups.filter(i => (props.showInheritedPermissions || i.permission.isExplicitPermission) &&
            (props.showUserGroups && i.type === UserGroupType.Normal || props.showUsers && i.type === UserGroupType.Fixed) &&
            (!props.filter || i.name.toLowerCase().indexOf(filterLow) > -1));
        const unitTitle = Translations.Unit + ": " + (props.parentName ? props.parentName + " / " : "") + unitNode.name;
        return (
            <div className={(props.classes ? " " + props.classes : "")}>
                {userGroups.length > 0 &&
                    <Box display="flex" flexDirection="column" sx={{ marginBottom: "1.5rem" }}>
                        <PanelTitle title={unitTitle} />
                        <List
                            intialized={true}
                            isLoading={false}
                            hasMore={false}
                            header={{
                                columns: [
                                    { size: props.additionalPermissionsInUse ? 4 : 6, column: "userGroup", content: Translations.UserGroup + "/" + Translations.User },
                                    { size: props.additionalPermissionsInUse ? 3 : 6, column: "name", content: Translations.Permission },
                                    props.additionalPermissionsInUse ? { size: 5, column: "additional", content: Translations.AdditionalPermissions } : null
                                ]
                            }}
                            lines={
                                userGroups.map((userGroup) => {
                                    const permission = userGroup.permission.permission;
                                    const permissionText = (EnumHelper.isGreaterOrEqualThan(permission, GroupPermissionLevel.Write)
                                        ? props.accessRightWriteTitle
                                        : (EnumHelper.isEqual(permission, GroupPermissionLevel.Read) ? props.accessRightReadTitle : props.accessRightNoneTitle));
                                    const additionalPermissionText = (props.getAdditionalPermissionInUse(permission, 0) && userGroup.permission.additionalPermissionA > 0 ? " + " + props.additionalPermissionTitle[0] : "") +
                                        (props.getAdditionalPermissionInUse(permission, 1) && userGroup.permission.additionalPermissionB > 0 ? " + " + props.additionalPermissionTitle[1] : "") +
                                        (props.getAdditionalPermissionInUse(permission, 2) && userGroup.permission.additionalPermissionC > 0 ? " + " + props.additionalPermissionTitle[2] : "");
                                    return {
                                        columns: [
                                            { size: props.additionalPermissionsInUse ? 4 : 6, content: userGroup.name },
                                            { size: props.additionalPermissionsInUse ? 3 : 6, content: permissionText },
                                            props.additionalPermissionsInUse ? { size: 5, content: additionalPermissionText } : null
                                        ],
                                        id: userGroup.name,
                                        classes: userGroup.permission.isExplicitPermission ? "" : "inherited"
                                    };
                                })
                            }
                            sortColumn={""}
                            sortOrderIsAsc={true}
                            selectedId={""}
                            onSetSelectedIds={null}
                            onSearchLines={null}
                        />
                    </Box>
                }
                {unitNode.children.map((childUnitNode) =>
                    <UnitPermissionSummaryTable
                        key={childUnitNode.id}
                        unitNode={childUnitNode}
                        parentName={unitNode.name}
                        accessRightNoneTitle={props.accessRightNoneTitle}
                        accessRightReadTitle={props.accessRightReadTitle}
                        accessRightWriteTitle={props.accessRightWriteTitle}
                        additionalPermissionTitle={props.additionalPermissionTitle}
                        additionalPermissionsInUse={props.additionalPermissionsInUse}
                        showInheritedPermissions={props.showInheritedPermissions}
                        showUserGroups={props.showUserGroups}
                        showUsers={props.showUsers}
                        filter={props.filter}
                        getAdditionalPermissionInUse={props.getAdditionalPermissionInUse}
                    />
                )}
            </div>
        );
    }
}